import { KALIBRASYON_UYARI_KALIPLARI } from "./kalibrasyon.js";
import { NDT_UYARI_KALIPLARI } from "./ndt-raporu.js";
import { kimlikSade } from "./sarf.js";
import { TESLIM_OKUMA_DEGISTI_METNI, TESLIM_SERI_EN_UZUN, TESLIM_SN_EN_COK, TESLIM_SN_EN_UZUN, pnSade } from "./teslim-listesi.js";
/** Dönüşüm işinin belge türü (`donusum_isi.belge_turu`). Riser Documentation'daki `DOSYA_TUR_ADI.uygunluk_sertifikasi` başka ad alanıdır. */
export const UYGUNLUK_BELGE_TURU = "uygunluk_sertifikasi";
/** Okunan Documents türü (GELEN_TURLERI anahtarı, "Certificate of conformity (CoC)"; Registers grubu, kütük sınıfı). */
export const UYGUNLUK_GELEN_TURU = "kutuk:stok_paket:coc";
export const uygunlukGelenTuruMu = (t) => t === UYGUNLUK_GELEN_TURU;
/** Olay kaydında nesne tipi (nesneId = uygunluk_sertifikasi_kaydi.id). */
export const UYGUNLUK_OLAY_NESNESI = "uygunluk_sertifikasi_kaydi";
/** Okunan hafif excel'in belge ailesi. Hiçbir aile sorgusu bu adı almaz (Riser Documentation, kanıt zinciri ve aile işlemleri). */
export const UYGUNLUK_GIRDI_AILESI = "Certificate-of-conformity-input";
/** DOCUMENT sayfasındaki "Document type" değeri. */
export const UYGUNLUK_EXCEL_ADI = "Certificate of conformity";
/** Okuma işi kodu ("CC-5A1B2C3D"); "COC-" uyarı kodlarından ayrı. */
export const uygunlukKodu = (kayitId) => `CC-${kayitId.replace(/-/g, "").slice(0, 8).toUpperCase()}`;
/** Bir CoC'de en çok satır (`Line`). */
export const UYGUNLUK_SATIR_EN_COK = 100;
/** Bir seri aralığının en çok SN sayısı (M4-6; bellek ve yanlış okuma koruması; aralık açılmaz). */
export const UYGUNLUK_ARALIK_EN_COK = 10000;
/**
 * Başlık alanları (DOCUMENT, 3; sabit sıra; sözleşme §14.3, sürüm 1). Her alanın tüketicisi sözleşmede ve `uygunluk-karsilastirma.ts`'te (`UYGUNLUK_OKUNAN`) yazılıdır. `etiket`
 * hem ekran metni hem DOCUMENT'teki Field adıdır. Kimlik: CoC no.
 */
export const UYGUNLUK_ALANLARI = [
    { alan: "coc_no", etiket: "CoC number", kimlik: true },
    { alan: "musteri_po", etiket: "Customer PO", kimlik: false },
    { alan: "sertifika_turu", etiket: "Certificate type", kimlik: false },
];
/** Satır alanları (ROWS, satır başına 3; sabit sıra; sözleşme §14.3). Kimlik: PN, lot, seri. */
export const UYGUNLUK_SATIR_ALANLARI = [
    { alan: "pn", etiket: "Part number", kimlik: true },
    { alan: "lot", etiket: "Lot", kimlik: true },
    { alan: "seri", etiket: "Serial numbers", kimlik: true },
];
/** Alanın ekran adı (iki listede aranır); bilinmiyorsa alanın kendisi. */
export const uygunlukEtiketi = (alan) => [...UYGUNLUK_ALANLARI, ...UYGUNLUK_SATIR_ALANLARI].find((a) => a.alan === alan)?.etiket ?? alan;
/** ROWS başlığı (uzun biçim: her hücre bir satır; `Line` okuma sırası). */
export const UYGUNLUK_SATIR_BASLIKLARI = ["Line", "Field", "Value", "As written", "Page", "Certainty"];
/** Kişinin "Add to package" onayının alanı (`belge_deger_onayi.alan`; kalemin parçasında, kalem başına bir kez). */
export const UYGUNLUK_EKLEME_ALANI = "kutuk_satiri";
/** `Certificate type` değerleri (M4-5). */
export const UYGUNLUK_TURLERI = ["2.1", "2.2", "3.1", "3.2", "none"];
/** M4-5: `Certificate type` değeri (kırpılmış; `none` büyük-küçük harfe duyarsız); başka her yazım null. */
export function uygunlukTuruOku(v) {
    const s = (v ?? "").trim();
    if (s.toLowerCase() === "none")
        return "none";
    return UYGUNLUK_TURLERI.includes(s) ? s : null;
}
const ARALIK_AYRACI = /\s+to\s+/i;
const SONDAKI_SAYI = /^(.*?)(\d+)$/;
/**
 * M4-6 (saf): `Serial numbers` değeri virgülle ayrılmış öğeler. Öğe tek SN (≤ 60 karakter) ya da `FIRST to LAST` aralığıdır: iki ucun `kimlikSade`'i sondaki rakam dizisiyle biter,
 * önekleri ve rakam dizilerinin uzunluğu eşit, `bas ≤ bit` ve en çok 10 000 SN. Boş öğe, 200'den çok öğe, 500 karakterden uzun hücre ya da kurala uymayan aralık → null.
 */
export function uygunlukSeriListesi(v) {
    const s = (v ?? "").trim();
    if (!s || s.length > TESLIM_SERI_EN_UZUN)
        return null;
    const parcalar = s.split(",").map((x) => x.trim());
    if (parcalar.length > TESLIM_SN_EN_COK || parcalar.some((x) => !x))
        return null;
    const ogeler = [];
    for (const p of parcalar) {
        const uclar = p.split(ARALIK_AYRACI);
        if (uclar.length === 1) {
            if (p.length > TESLIM_SN_EN_UZUN)
                return null;
            ogeler.push({ tur: "tek", sn: kimlikSade(p), yazi: p });
            continue;
        }
        if (uclar.length !== 2)
            return null;
        const [ilk, son] = uclar.map((x) => x.trim());
        if (!ilk || !son || ilk.length > TESLIM_SN_EN_UZUN || son.length > TESLIM_SN_EN_UZUN)
            return null;
        const a = SONDAKI_SAYI.exec(kimlikSade(ilk));
        const b = SONDAKI_SAYI.exec(kimlikSade(son));
        if (!a || !b || a[1] !== b[1] || a[2].length !== b[2].length)
            return null;
        const bas = Number(a[2]);
        const bit = Number(b[2]);
        if (bas > bit || bit - bas + 1 > UYGUNLUK_ARALIK_EN_COK)
            return null;
        ogeler.push({ tur: "aralik", onek: a[1], bas, bit, hane: a[2].length, yazi: p });
    }
    return ogeler;
}
/** M4-6 (saf): SN öğelerden biri tarafından kapsanıyor mu (tek SN'e eşit ya da aralığın önekiyle aynı hane sayısında ve sayısı aralıkta). */
export function seriKapsar(ogeler, sn) {
    const s = kimlikSade(sn);
    if (!s)
        return false;
    return ogeler.some((o) => {
        if (o.tur === "tek")
            return o.sn === s;
        if (!s.startsWith(o.onek))
            return false;
        const r = s.slice(o.onek.length);
        if (r.length !== o.hane || !/^\d+$/.test(r))
            return false;
        const n = Number(r);
        return n >= o.bas && n <= o.bit;
    });
}
/** Seri öğelerinin kısa metni (en çok 3 öğe, fazlası " …"; `kimlikListesi` kalıbı). */
export function uygunlukSeriMetni(ogeler, n = 3) {
    const xs = ogeler.map((o) => o.yazi);
    return xs.length > n ? `${xs.slice(0, n).join(", ")} …` : xs.join(", ");
}
const degerOf = (l, alan) => l.find((x) => x.alan === alan) ?? null;
const kesinMi = (d) => Boolean(d && d.kesinlik === "kesin" && d.deger !== null && d.deger.trim() !== "");
/** M4-7 (saf): her `Line` bir kalemdir (birleştirme yok); kalem sırası `Line`'dır. Şüpheli her değer için `suphe` notu. */
export function uygunlukKalemleri(satirlar) {
    const notlar = [];
    const kalemler = [...satirlar].sort((a, b) => a.no - b.no).map((s) => {
        const pn = degerOf(s.degerler, "pn");
        const lotD = degerOf(s.degerler, "lot");
        const seriD = degerOf(s.degerler, "seri");
        for (const d of s.degerler)
            if (d.kesinlik === "suphe")
                notlar.push({ tur: "suphe", kalem: s.no, alan: d.alan });
        const lot = kesinMi(lotD) ? lotD.deger.trim() : null;
        const seriler = kesinMi(seriD) ? (uygunlukSeriListesi(seriD.deger) ?? []) : [];
        return { sira: s.no, degerler: s.degerler, pn, pnSade: kesinMi(pn) ? pnSade(pn.deger) : null, lot, seriler, kimlikVar: Boolean(lot) || seriler.length > 0 };
    });
    return { kalemler, notlar };
}
/* ---------------- uyarılar ---------------- */
/**
 * Kartta üretilen kodlar (kalem uyarıları COC-01, TES-07; parçasızlar COC-02, COC-03, GEN-04, GEN-09). Hiçbiri KAPALI_UYARI_KODLARI'nda olamaz (test). MTL-07 ve GEN-06 kapalıdır;
 * TES-01 … TES-06, GEN-02, GEN-11, GEN-13, GEN-15, GEN-17, GEN-19 ve GEN-20 bu kartta üretilmez.
 */
export const UYGUNLUK_UYARI_KODLARI = ["COC-01", "TES-07", "COC-02", "COC-03", "GEN-04", "GEN-09"];
/** Uyarı kalıpları (İngilizce anahtar; Türkçesi sözlükte). COC-01'in varyantları planın kalıbının yazılmış hâlidir (kod aynı). GEN-04 ve GEN-09 öteki okuyucularınkiyle aynıdır. */
export const UYGUNLUK_UYARI_KALIPLARI = {
    coc01Lot: "CoC items differ from the packing list: {0} lot {1} on the CoC, {2} on the packing list.",
    coc01Seri: "CoC items differ from the packing list: {0} serial number {1} on the packing list is not on the CoC ({2}).",
    tes07: "Line only on the CoC, not on any packing list: {0}.",
    coc02: "CoC lists items of other orders.",
    coc03: "Declaration only (EN 10204 2.1): no test results.",
    gen04: KALIBRASYON_UYARI_KALIPLARI["GEN-04"],
    gen09: NDT_UYARI_KALIPLARI["GEN-09"],
};
/** Saf (M4-18): kartın durumu ve yazımın ön denetimi aynı kuraldır; ilk tutan döner. `engel` yalnız "engel" durumunda dolu. */
export function uygunlukKalemEngeli(d) {
    const ol = (durum, engel = null) => ({ durum, engel });
    if (d.kapali)
        return ol("kapali");
    if (!d.yerVar)
        return ol("yer_yok");
    if (!d.okumaGuncel)
        return ol("engel", TESLIM_OKUMA_DEGISTI_METNI);
    if (d.engel)
        return ol("engel", d.engel);
    if (d.pakette || d.onay)
        return ol("pakette");
    if (d.acik)
        return ol("dosyalanmadi");
    return ol("eklenebilir");
}
//# sourceMappingURL=uygunluk-sertifikasi.js.map